import styled from "@emotion/styled";
import { LinearProgress, linearProgressClasses } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

interface QuranProgressCardProps {
  userProgress: {
    progressString: string;
    percentageValue: number;
  };
}

const QuranProgressCard: React.FC<QuranProgressCardProps> = ({
  userProgress,
}) => {
  const navigate = useNavigate();
  const taskPercentageCompleted = 20;

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 30,
    borderRadius: 999,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: "#FFFFFF",
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 999,
      backgroundColor: "#88CE3D",
    },
  }));
  return (
    <>
      <div
        className="bg-[#036900] rounded-[2.8em] px-[2em] py-[2em] mt-8 cursor-pointer"
        onClick={() => navigate("/quran")}
      >
        <h1 className="font-grgrifter text-4xl tracking-wider text-white">
          QURAN
        </h1>
        <h2 className="font-grgrifter text-lg tracking-wider text-[#8BC250] opacity-80">
          {userProgress.progressString}
        </h2>

        <div className="pb-[1em] mt-8">
          <div className="progress-container">
            <p className="percentage font-grgrifter">
              {userProgress.percentageValue}
              <span className="symbol font-grgrifter ml-1 text-[#8BC250]">
                %
              </span>
            </p>
          </div>

          <div className="progress-bar">
            <div className="top-progress-bar">
              <BorderLinearProgress
                variant="determinate"
                value={userProgress.percentageValue}
              />
            </div>

            {/* <BorderLinearProgress
                  className="bottom-progress-bar"
                  variant="determinate"
                  value={userProgress.percentageValue}
                /> */}
          </div>

          {/* <p className="progress-bar-label">
                of the day completed &{" "}
                <span className="tasks-percentage">
                  {taskPercentageCompleted}%{" "}
                </span>
                tasks completed
              </p> */}
        </div>

        <button className="w-full flex items-center justify-center rounded-[2em] cursor-pointer mt-6">
          {/* <ShowIcon size={18} className="mr-2" color="#3A9437" /> */}
          <p className="font-grgrifter text-sm tracking-widest text-center text-[#FFF]">
            {"Open Quran >"}
          </p>
        </button>
      </div>
    </>
  );
};

export default QuranProgressCard;
